import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const INSTITUTION_REFERENCE = process.env.REACT_APP_INSTITUTION_REFERENCE;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const buildCdnUrl = path => {
  if (!path) return "";
  return `${CDN_URL?.replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;
};
